import React from 'react';
import { Button } from '../../../common-components/Button/Button';
import { If } from '../../../common-components/If/If';
import { strings } from '../../../resources/strings';
import { Container } from './styles';

interface IActionsForManageCustomersProps {
    filtering?: boolean;
    appliedFilters?: number;
    updateList?: () => void;
    filterList?: () => void;
    clearFilter?: () => void;
    newRegister?: () => void;
}

const ActionsForManageCustomers: React.FC<IActionsForManageCustomersProps> = ({
    filtering,
    appliedFilters,
    updateList,
    filterList,
    clearFilter,
    newRegister
}) => {

    return (
        <Container>
            <Button text={strings.Filter} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'80px'} click={filterList} /> 

            <If condition={!!appliedFilters}>
                <Button text={strings.Clear} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'80px'} click={clearFilter} /> 
            </If>

            <Button text={strings.Update} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'80px'} click={updateList} /> 

            <Button text={strings.New} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'80px'} click={newRegister} /> 
        </Container>
    );
}

export {ActionsForManageCustomers};